// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { format as fn } from "../format.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const format = convertToFP(fn, 2);

// Fallback for modularized imports:
export default format;
